<template>
  <div>

    <div class="login-container">
        <el-form class="login-form">
        
        <!--   <h3 class="title">东方国信工业互联网产业学院</h3>
  -->
          <el-form-item prop="username">
            <span class="svg-container fl">
              <i class="iconfont icon-user"></i>
            </span>
            <el-input
              name="username"
              type="text"
              style="width:100%;"
              v-model="loginForm.username"
              autocomplete="off"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <span class="svg-container fl">
              <i class="iconfont icon-password"></i>
            </span>
            <el-input
              style="width:100%;"
              name="password"
              type="password"
              @keyup.enter.native="handleLogin"
              v-model="loginForm.password"
              autocomplete="off"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="width:100%;"
              :loading="loading"
              @click.native.prevent="handleLogin"
            >登录</el-button>
          </el-form-item>
          <div class="prompt">
              为了在实训中更好的体验，建议使用<a href="https://www.google.cn/chrome/thank-you.html?statcb=1&installdataindex=empty&defaultbrowser=0#"> chrome浏览器&nbsp;</a>
          </div>
        </el-form>
        
      <div class="logo">
          <img width="100%" src="../assets/img/logo2.png" alt="">
        </div>
    </div>
  </div>
</template>
<script>
import ajaxObj from "@/ajax";
import { dynamicRouter } from "@/router/index";
export default {
  name: "login",
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
   
    };
  },
 
  methods: {
    handleLogin() {
     
      this.loading = true;
      ajaxObj({
        url: process.env.URL + "login",
        method: "get",
        params: {
          username: this.loginForm.username,
          password: this.loginForm.password,
        }
      }).then(response => {
        window.localStorage.clear();
        window.localStorage.setItem('access_token',response.data.accessToken);
        window.localStorage.setItem('username',response.data.userName);


        ajaxObj({
          url: "roles/my-permissions",
          method: "get"
        }).then(response => {
          this.$root.$children[0].init()


             //this.$router.push("lessonManagement");
         

        });
      });
  
    }
  }
};
</script>

<style scoped>
.login-container {
  position: relative;
  width: 100%;
  height: 100%;
  height: 100vh;
  /* background-color: #2d3a4b;*/
  background-image: url("../assets/img/loginBack.png");
  background-size: 100% 100%;
}

.login-container .title {
  font-size: 26px;
  font-weight: 400;
  color: #eeeeee;
  margin: 0px auto 40px auto;
  text-align: center;
  font-weight: bold;
}


.img {
  position: fixed;
  top: 10px;
  right: 10px;
  margin: 0px auto;
  text-align: center;
  height: 66px;
  margin-right: 10px;
 /* width: 130px;
  height: 130px;*/
 /* margin-bottom: 10px;*/
  
}

.login-form {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 1000px;
  padding: 35px 35px 15px 35px;
  transform: translate(-50%, -70%);
  text-align: center;
  margin-top: 50px;
}
.svg-container {
  margin: 4px -5px 0 10px;
  color: #889aa4;
}
i {
  font-size: 18px;
}
.el-form {
}
.login-container /deep/ .el-input {
  display: inline-block;
  height: 47px;
  width: 85%;
}

.login-container /deep/  .input {
  background: transparent;
  border: 0px;
  -webkit-appearance: none;
  border-radius: 0px;
  padding: 12px 5px 12px 15px;
  color: #eeeeee;
  height: 47px;
}
.login-container /deep/  .el-form-item {
  margin-bottom: 30px !important;
  width: 500px;
  margin: 0 auto;

  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  color: #454545;
}

.login-container /deep/  input {
  background: transparent;
  border: 0px;
  -webkit-appearance: none;
  border-radius: 0px;
  padding: 12px 5px 12px 15px;
  color: #eeeeee;
  height: 47px;
}
.logo {
    width: 200px;
    height: 100px;
    position: fixed;
    left: 20px;
    top: 20px;
}
.prompt {
    width: 1000px;
    position: absolute;
    color: #FFFFFF;
    font-size: 18px;
    padding-top: 10px;
    margin:  0 auto;
}
.prompt a {
    color: #FFFFFF;
    text-decoration:underline;
    font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue